import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const ProductContext = React.createContext();

export const defaultContext = {
    getModelId: () => undefined,
    handleTabChange: () => undefined,
    modifyProductWithVariant: () => undefined,
    updateSelectedAddOns: () => undefined,
    selectedColor: () => undefined,
    changeColor: () => undefined,
    product: {},
    colorGroup:  {
        displayName: "Color",
        key: "color",
        values: []
    },
    enableShippingBanner: false,
    showCarepackModule: false,
    carePacks: [],
    isSmb: false,
    disableAlertBanner: false,
    template: 'pdp'
}

export const ProductConsumer = (props) => {
    return(
        <ProductContext.Consumer>
            {
                (productContext)=> props.children(productContext)
            }
        </ProductContext.Consumer>
    );
}

export const withProductConsumer = (Component) => {
    return class extends React.Component {
        render() {
            return(
                <ProductContext.Consumer>
                    {
                        (productContext) =>{
                            return(
                                <Component
                                    {...this.props}
                                    productContext={productContext}
                                />
                            )
                        }
                    }
                </ProductContext.Consumer>
            )
        }
    }
}

export class ProductProvider extends React.Component {

    state = null;

    constructor(props) {
        super(props);
        this.state = this.props.productContext;
    }

    componentDidUpdate(prevProps){
        if(prevProps.productContext != this.props.productContext)this.setState(this.props.productContext);
    }

    render(){
        return (
                <ProductContext.Provider value={this.state}>
                    {this.props.children}
                </ProductContext.Provider>
        )
    }
}
